import { startCase } from 'lodash-es'
import type { DateTime } from 'luxon'
import type {
  ContainerType,
  GETLineImportStatus,
  LineStatus,
  PortalName,
  ShippingLine,
  TerminalName,
} from '~/services/apiClient'
import { getPortalLabel } from '~/constants'
import { fastParseISO } from '~/utils'

export class LineImportStatus {
  id: number
  container_number: string
  status: string
  parsed_status: LineStatus
  terminal: TerminalName
  last_free_day: DateTime | null
  source: PortalName
  observed: DateTime
  last_observed: DateTime
  last_observed_changed: DateTime
  parsed_shipping_line: ShippingLine | null
  parsed_container_type: ContainerType | null
  master_bill_of_lading: string | null

  constructor(status: GETLineImportStatus) {
    this.id = status.id
    this.container_number = status.container_number
    this.status = status.status
    this.parsed_status = status.parsed_status
    this.terminal = status.terminal
    this.last_free_day = status.last_free_date
      ? fastParseISO(status.last_free_date)
      : null
    this.source = status.source
    this.observed = fastParseISO(status.observed)
    this.last_observed = fastParseISO(status.last_observed)
    this.last_observed_changed = fastParseISO(status.observed)
    this.parsed_shipping_line = status.parsed_shipping_line ?? null
    this.parsed_container_type = status.parsed_container_type ?? null
    this.master_bill_of_lading = status.master_bill_of_lading ?? null
  }

  get sourceLabel(): string {
    return getPortalLabel(this.source)
  }

  get statusDescription(): string {
    return startCase(this.parsed_status.replace('_', ' '))
  }
}
